import React from 'react';
import Sidebar from '../sidebar';
import BulkIngestionContent from './BulkIngestionContent';

export default function BulkIngestion(): JSX.Element {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar variant='main' activeLink='bulk-ingestion' />
      <BulkIngestionContent />
    </div>
  );
}
